<script setup>

</script>

<template>
  <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.04883 1C9.04883 0.447715 8.60111 -2.41411e-08 8.04883 0C7.49654 2.41411e-08 7.04883 0.447715 7.04883 1L9.04883 1ZM7.34172 16.7071C7.73225 17.0976 8.36541 17.0976 8.75594 16.7071L15.1199 10.3431C15.5104 9.95262 15.5104 9.31946 15.1199 8.92893C14.7294 8.53841 14.0962 8.53841 13.7057 8.92893L8.04883 14.5858L2.39197 8.92893C2.00145 8.53841 1.36829 8.53841 0.977761 8.92893C0.587236 9.31946 0.587236 9.95262 0.977761 10.3431L7.34172 16.7071ZM7.04883 1L7.04883 16L9.04883 16L9.04883 1L7.04883 1Z"
        fill="currentColor"/>
  </svg>


</template>

<style lang="scss" scoped>

</style>